import React from 'react';

const LoadingIndicator = ({ message = 'Loading data...', progress = '' }) => {
  return (
    <div className="flex flex-col items-center justify-center h-64">
      <div className="spinner mb-4"></div>
      <p className="text-gray-600 font-medium">{message}</p>
      
      {progress && (
        <p className="text-sm text-gray-500 mt-1">{progress}</p>
      )}
      
      <div className="mt-4 max-w-md text-center">
        <p className="text-xs text-gray-500 mb-1">
          Using optimized loading for large datasets (24 charts per page)
        </p>
        <p className="text-xs text-gray-500">
          Data is loaded on-demand with Airtable's pagination API
        </p>
      </div>
    </div>
  );
};

export default LoadingIndicator;
